import { Plus, Truck, Bell, FileCheck, Wallet, Home, ListChecks, User, ChevronLeft, AlertTriangle, Container, Phone, MapPin, Camera } from "lucide-react";
import { KuwaitPlate } from "@/components/KuwaitPlate";

const B = "#0047AB";

export const Phone390 = ({ children, testid }) => (
  <div className="w-[370px] max-w-full mx-auto h-[740px] rounded-[2.6rem] border-[10px] border-black overflow-hidden shadow-2xl relative bg-white" style={{ fontFamily: "'Almarai', sans-serif" }} data-testid={testid}>
    <div className="absolute inset-0 overflow-y-auto pb-24">{children}</div>
  </div>
);

const BigTile = ({ icon: I, title, value, sub, solid }) => (
  <div className={`rounded-3xl p-4 border-[3px] flex flex-col gap-3 min-h-[150px] ${solid ? "text-white" : "bg-white"}`} style={{ borderColor: B, background: solid ? B : undefined, color: solid ? "#fff" : B }}>
    <div className="flex items-center justify-between"><I className="w-10 h-10" strokeWidth={2.4} /><span className="text-4xl font-black">{value}</span></div>
    <div><div className="text-xl font-black">{title}</div><div className={`text-sm font-bold ${solid ? "text-white/80" : "text-slate-500"}`}>{sub}</div></div>
  </div>
);

export const BottomNav = ({ active = "home" }) => (
  <div className="absolute bottom-0 inset-x-0 h-[76px] bg-white border-t-[3px] flex items-center justify-around px-2" style={{ borderColor: B }}>
    {[["home", "الرئيسية", Home], ["trips", "نقلاتي", ListChecks], ["alerts", "إشعاراتي", Bell], ["me", "حسابي", User]].map(([k, l, I]) => (
      <span key={k} className={`flex flex-col items-center gap-0.5 rounded-2xl px-4 py-1.5 text-xs font-black ${active === k ? "text-white" : ""}`} style={{ background: active === k ? B : undefined, color: active === k ? "#fff" : B }}>
        <I className="w-7 h-7" strokeWidth={2.4} />{l}
      </span>
    ))}
  </div>
);

export function DriverHomeBold() {
  return (
    <Phone390 testid="bold-driver-home">
      <div className="text-white px-4 pt-4 pb-5 rounded-b-[2rem]" style={{ background: B }}>
        <div className="flex items-center gap-3">
          <img src="/img/logo.png" alt="" className="w-14 h-14 rounded-full bg-white p-0.5 object-contain" />
          <div className="flex-1"><div className="text-sm font-bold text-white/80">مرحباً</div><div className="text-2xl font-black">محمد العنزي</div></div>
          <span className="relative w-12 h-12 rounded-2xl bg-white flex items-center justify-center" style={{ color: B }}><Bell className="w-7 h-7" strokeWidth={2.4} /><span className="absolute -top-1 -left-1 w-6 h-6 rounded-full bg-red-600 text-white text-xs font-black flex items-center justify-center border-2 border-white">2</span></span>
        </div>
        <div className="mt-4 bg-white rounded-2xl p-3 flex items-center justify-between" style={{ color: B }}>
          <KuwaitPlate adm="20" plate="45454" />
          <div className="text-center"><Truck className="w-10 h-10 mx-auto" strokeWidth={2.4} /><b className="text-lg">ونش</b></div>
        </div>
      </div>
      <div className="p-4 space-y-4">
        <div className="rounded-3xl text-white p-5 flex items-center justify-between shadow-[0_10px_0_#00317A] active:translate-y-1 transition-transform" style={{ background: B }}>
          <div><div className="text-3xl font-black">نقلة جديدة</div><div className="text-white/80 font-bold">اضغط وابدأ فوراً</div></div>
          <span className="w-16 h-16 rounded-2xl bg-white flex items-center justify-center" style={{ color: B }}><Plus className="w-10 h-10" strokeWidth={3.5} /></span>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <BigTile icon={Truck} title="نقلاتي" value="2" sub="قيد التنفيذ" solid />
          <BigTile icon={Bell} title="إشعاراتي" value="2" sub="جديدة" />
          <BigTile icon={FileCheck} title="مستنداتي" value="4" sub="كلها سارية" />
          <BigTile icon={Wallet} title="حسابي" value="15" sub="د.ك متبقي" />
        </div>
        <div className="rounded-2xl border-[3px] border-red-600 bg-red-50 p-4 flex items-center gap-3">
          <AlertTriangle className="w-9 h-9 text-red-600 shrink-0" strokeWidth={2.4} />
          <div className="flex-1"><b className="text-red-700 text-lg block">مخالفة جديدة</b><span className="text-sm font-bold text-red-700/80">على المركبة 20/45454 — اضغط للاطلاع</span></div>
          <ChevronLeft className="w-6 h-6 text-red-600" />
        </div>
      </div>
      <BottomNav />
    </Phone390>
  );
}

const BigInput = ({ icon: I, label, value }) => (
  <div>
    <div className="font-black text-lg mb-1.5" style={{ color: B }}>{label}</div>
    <div className="h-16 rounded-2xl border-[3px] flex items-center gap-3 px-4 text-lg font-bold text-slate-800" style={{ borderColor: B }}><I className="w-7 h-7 shrink-0" style={{ color: B }} strokeWidth={2.4} />{value}</div>
  </div>
);

export function NewTripBold() {
  return (
    <Phone390 testid="bold-new-trip">
      <div className="text-white px-4 py-5 flex items-center gap-3" style={{ background: B }}>
        <span className="w-12 h-12 rounded-2xl bg-white/15 flex items-center justify-center text-2xl font-black">→</span><h2 className="text-2xl font-black">نقلة جديدة</h2>
      </div>
      <div className="p-4 space-y-4">
        <div className="font-black text-lg" style={{ color: B }}>نوع الخدمة</div>
        <div className="grid grid-cols-2 gap-3">
          <div className="rounded-3xl p-4 text-white flex flex-col items-center gap-2 border-[3px]" style={{ background: B, borderColor: B }}><Truck className="w-14 h-14" strokeWidth={2.2} /><b className="text-xl">ونش</b><span className="text-xs font-bold">✔ مختار</span></div>
          <div className="rounded-3xl p-4 bg-white flex flex-col items-center gap-2 border-[3px]" style={{ borderColor: B, color: B }}><Container className="w-14 h-14" strokeWidth={2.2} /><b className="text-xl">هاف لوري</b><span className="text-xs font-bold text-slate-400">اضغط للاختيار</span></div>
        </div>
        <BigInput icon={Phone} label="هاتف طالب النقل" value="9911 2233" />
        <div>
          <div className="font-black text-lg mb-1.5" style={{ color: B }}>لوحة السيارة المنقولة</div>
          <div className="flex gap-2"><div className="w-24 h-16 rounded-2xl border-[3px] flex items-center justify-center text-2xl font-black" style={{ borderColor: B }}>21</div><div className="flex-1 h-16 rounded-2xl border-[3px] flex items-center px-4 text-2xl font-black ltr" style={{ borderColor: B }}>45678</div></div>
        </div>
        <BigInput icon={MapPin} label="من" value="الجهراء" />
        <div className="h-16 rounded-2xl border-[3px] border-dashed flex items-center justify-center gap-2 font-black text-lg" style={{ borderColor: B, color: B }}><Camera className="w-7 h-7" />أضف صور السيارة</div>
        <div className="h-16 rounded-2xl text-white flex items-center justify-center text-2xl font-black shadow-[0_8px_0_#00317A]" style={{ background: B }}>حفظ النقلة</div>
      </div>
    </Phone390>
  );
}
